import sdk from './sdk';

export function track(event, data) {
	if (window.sa && window.sa.track) {
		const userInfo = sdk.getUserInfo();

		if (userInfo) {
			const { oaid = '', 'app-name': appName = 'kuaiyin', device_new_time = '' } = userInfo;

			data.time = new Date().getTime();
			data.oaid = oaid;
			data.package_type = appName;
			data.device_new_time = device_new_time;
		}

		window.sa.track(event, data);
	}
}

export function trackAiMusic(event, data) {
	if (window.sa && window.sa.track) {
		window.sa.track(event, data);
	}
}
export function trackClick(data, event) {
	data = Object.assign({}, data);

	if (data.remarks) data.remarks = removeEmoji(String(data.remarks));
	if (data.page_title) data.page_title = removeEmoji(String(data.page_title));
	if (data.element_name) data.element_name = removeEmoji(String(data.element_name));
	// 20240328 叶老师：page_title='长期裂变页' 的埋点 都下掉.
	// if (data.page_title === '长期裂变页') {
	// 	return;
	// }
	// 20250103 成润东要求恢复裂变埋点
	track(event || 'element_click', {
		page_title: data.page_title || '',
		element_type: data.element_type || 'button',
		element_name: data.element_name || '',
		music_user_id: data.music_user_id || '',
		music_id: data.music_id || '',
		music_code: data.music_code || '',
		pv_id: data.pv_id || '',
		remarks: data.remarks || '',
	});
}

export function trackAiMusicClick(data, event) {
	data = Object.assign({}, data);

	if (data.remarks) data.remarks = removeEmoji(String(data.remarks));
	if (data.page_title) data.page_title = removeEmoji(String(data.page_title));
	if (data.element_name) data.element_name = removeEmoji(String(data.element_name));
	if (data.uid) data.uid = removeEmoji(String(data.uid));

	console.log(data, event, 'trackAiMusicClick');

	trackAiMusic(event || 'aimusic_click', {
		page_title: data.page_title || '',
		element_type: data.element_type || 'button',
		element_name: data.element_name || '',
		remarks: data.remarks || '',
		uid: data.uid || '',
		package_type: 'mp_wx',
		app_version: '1.0.0',
	});
}
export function trackAdVideo(data) {
	data = Object.assign({}, data);
	track('ad_funnel', {
		ad_type: data.ad_type || '',
		is_master: data.is_master || '',
		ad_platform: videoTypeMap[data.ad_platform] || '',
		ad_source: data.ad_source || '',
		ad_position: data.ad_position || '',
		app_position: data.app_position || '',
		page_type: 'H5',
		ad_stage: data.ad_stage || '',
		is_success: Number(data.is_success),
		music_content_id: data.music_content_id || '',
		ad_hash: data.ad_hash || '',
		error: data.error || '',
	});
}

const videoTypeMap = {
	gdt: '广点通',
	ocean_engine: '穿山甲',
	hytt: '东方头条',
	kuaiyin: '快音',
	admobile: '艾狄墨搏',
};

function removeEmoji(msg) {
	return msg
		.replace(
			/([#0-9]\u20E3)|[\xA9\xAE\u203C\u2047-\u2049\u2122\u2139\u3030\u303D\u3297\u3299][\uFE00-\uFEFF]?|[\u2190-\u21FF][\uFE00-\uFEFF]?|[\u2300-\u23FF][\uFE00-\uFEFF]?|[\u2460-\u24FF][\uFE00-\uFEFF]?|[\u25A0-\u25FF][\uFE00-\uFEFF]?|[\u2600-\u27BF][\uFE00-\uFEFF]?|[\u2900-\u297F][\uFE00-\uFEFF]?|[\u2B00-\u2BF0][\uFE00-\uFEFF]?|(?:\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDEFF])[\uFE00-\uFEFF]?|[\u20E3]|[\u26A0-\u3000]|\uD83E[\udd00-\uddff]|[\u00A0-\u269F]/g,
			''
		)
		.trim();
}



// WEBPACK FOOTER //
// ./src/lib/track.js